/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_SubtitleInputs */

const id_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lacak harga, temukan diskon, dan jangan pernah lewatkan game gratis. Pendamping Anda untuk database Epic Games Store — penawaran, diskon, giveaway, build, dan banyak lagi.`)
};

const ms_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jejak harga, temui tawaran, dan jangan sesekali terlepas permainan percuma. Rakan anda untuk pangkalan data Epic Games Store — tawaran, diskaun, pemberian, binaan, dan banyak lagi.`)
};

const da_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spor priser, opdag tilbud, og gå aldrig glip af et gratis spil. Din følgesvend til Epic Games Store databasen — tilbud, rabatter, giveaways, builds og mere.`)
};

const de_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfolgen Sie Preise, entdecken Sie Angebote und verpassen Sie nie wieder ein kostenloses Spiel. Ihr Begleiter für die Epic Games Store-Datenbank — Angebote, Rabatte, Giveaways, Builds und mehr.`)
};

const en_us2_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track prices, discover deals, and never miss a free game. Your companion for the Epic Games Store database — offers, discounts, giveaways, builds, and more.`)
};

const es_es2_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rastrea precios, descubre juegos y nunca te pierdas un juego gratis. Tu compañero para la base de datos de la Epic Games Store — juegos, descuentos, regalos, compilaciones y más.`)
};

const es_mx2_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rastrea precios, descubre ofertas y nunca te pierdas un juego gratis. Tu compañero para la base de datos de la Epic Games Store — ofertas, descuentos, regalos, compilaciones y más.`)
};

const fil_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subaybayan ang mga presyo, tumuklas ng mga deal, at huwag palampasin ang libreng laro. Iyong kasama para sa Epic Games Store database — mga offer, diskwento, giveaway, build, at marami pa.`)
};

const fr_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivez les prix, découvrez les bonnes affaires et ne manquez jamais un jeu gratuit. Votre compagnon pour la base de données de l'Epic Games Store — offres, réductions, gratuités, compilations et plus.`)
};

const it_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traccia i prezzi, scopri le offerte e non perdere mai un gioco gratuito. Il tuo compagno per il database dell'Epic Games Store — offerte, sconti, giveaway, build e altro ancora.`)
};

const hu_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kövesd az árakat, fedezd fel az ajánlatokat, és soha ne maradj le egy ingyenes játékról sem. A társad az Epic Games Store adatbázisához — ajánlatok, kedvezmények, ajándékok, build-ek és több.`)
};

const nl_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volg prijzen, ontdek deals en mis nooit een gratis game. Jouw metgezel voor de Epic Games Store database — aanbiedingen, kortingen, giveaways, builds en meer.`)
};

const no_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spor priser, oppdag tilbud, og gå aldri glipp av et gratis spill. Din følgesvenn for Epic Games Store-databasen — tilbud, rabatter, giveaways, builds og mer.`)
};

const pl_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Śledź ceny, odkrywaj promocje i nie przegap żadnej darmowej gry. Twój towarzysz bazy danych Epic Games Store — oferty, promocje, rozdania, kompilacje i więcej.`)
};

const pt_br2_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acompanhe preços, descubra jogos e nunca perca um jogo grátis. Seu companheiro para a base de dados da Epic Games Store: jogos, descontos, brindes, builds e muito mais.`)
};

const pt_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acompanhe preços, descubra promoções e nunca perca um jogo grátis. O seu companheiro para a base de dados da Epic Games Store — ofertas, descontos, brindes, compilações e muito mais.`)
};

const ro_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urmărește prețurile, descoperă oferte și nu rata niciodată un joc gratuit. Însoțitorul tău pentru baza de date Epic Games Store — oferte, reduceri, cadouri, compilări și multe altele.`)
};

const fi_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seuraa hintoja, löydä tarjouksia ja älä koskaan missaa ilmaista peliä. Kumppanisi Epic Games Store -tietokantaan — tarjoukset, alennukset, ilmaisjaot, koontiversiot ja paljon muuta.`)
};

const sv_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spåra priser, upptäck erbjudanden och missa aldrig ett gratis spel. Din följeslagare för Epic Games Store-databasen — erbjudanden, rabatter, utlottningar, byggen och mer.`)
};

const vi_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theo dõi giá cả, khám phá ưu đãi và không bao giờ bỏ lỡ game miễn phí. Người bạn đồng hành của bạn cho cơ sở dữ liệu Epic Games Store — ưu đãi, giảm giá, tặng miễn phí, bản dựng và hơn thế nữa.`)
};

const tr_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiyatları takip edin, fırsatları keşfedin ve hiçbir ücretsiz oyunu kaçırmayın. Epic Games Store veritabanı için yol arkadaşınız — teklifler, indirimler, bedava oyunlar, yapılar ve daha fazlası.`)
};

const cs_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sledujte ceny, objevujte slevy a nikdy nezmeškejte hru zdarma. Váš průvodce databází Epic Games Store — nabídky, slevy, výprodeje, sestavení a další.`)
};

const bg_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проследявайте цени, откривайте оферти и не пропускайте безплатна игра. Вашият спътник за базата данни на Epic Games Store — оферти, отстъпки, безплатни игри, компилации и още.`)
};

const ru_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отслеживайте цены, находите выгодные предложения и не пропускайте бесплатные раздачи игр. Ваш помощник по базе данных Epic Games Store — предложения, акции, скидки, раздачи, сборки и многое другое.`)
};

const uk_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відстежуйте ціни, знаходьте пропозиції та не пропускайте безкоштовні ігри. Ваш помічник для бази даних Epic Games Store — пропозиції, знижки, роздачі, збірки тощо.`)
};

const ar_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تتبع الأسعار، واكتشف الصفقات، ولا تفوت أي لعبة مجانية. رفيقك لقاعدة بيانات Epic Games Store — العروض، الخصومات، الهدايا، البنيات، والمزيد.`)
};

const hi_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कीमतों पर नज़र रखें, सौदे खोजें, और कोई भी मुफ़्त गेम मिस न करें। Epic Games Store डेटाबेस के लिए आपका साथी — ऑफ़र, छूट, गिवअवे, बिल्ड, और बहुत कुछ।`)
};

const th_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ติดตามราคา ค้นหาข้อเสนอดี ๆ และไม่พลาดเกมฟรีสักเกม คู่หูของคุณสำหรับฐานข้อมูล Epic Games Store — ข้อเสนอ ส่วนลด ของแจกฟรี บิลด์ และอื่น ๆ`)
};

const ja_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格を追跡し、お得な情報を見つけ、無料ゲームを見逃しません。Epic Games Store データベースのコンパニオン — オファー、割引、配布、ビルドなど。`)
};

const zh_cn2_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追踪价格、发现折扣、不错过任何一款免费游戏。您的Epic游戏商城数据库伴侣 — 提供目录项、折扣、赠送、构建版本等信息。`)
};

const zh_hant1_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追蹤價格、發現折扣、不錯過任何一款免費遊戲。您的Epic遊戲商城資料庫伴侶 — 提供目錄項目、折扣、贈送、建置版本等資訊。`)
};

const ko_home_hero_subtitle = /** @type {(inputs: Home_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가격을 추적하고, 할인을 발견하고, 무료 게임을 놓치지 마세요. Epic Games Store 데이터베이스 — 오퍼, 할인, 무료 배포, 빌드 등을 위한 당신의 동반자입니다.`)
};

/**
* | output |
* | --- |
* | "Track prices, discover deals, and never miss a free game. Your companion for the Epic Games Store database — offers, discounts, giveaways, builds, and more." |
*
* @param {Home_Hero_SubtitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_hero_subtitle = /** @type {((inputs?: Home_Hero_SubtitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_SubtitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_hero_subtitle(inputs)
	if (locale === "ms") return ms_home_hero_subtitle(inputs)
	if (locale === "da") return da_home_hero_subtitle(inputs)
	if (locale === "de") return de_home_hero_subtitle(inputs)
	if (locale === "en-US") return en_us2_home_hero_subtitle(inputs)
	if (locale === "es-ES") return es_es2_home_hero_subtitle(inputs)
	if (locale === "es-MX") return es_mx2_home_hero_subtitle(inputs)
	if (locale === "fil") return fil_home_hero_subtitle(inputs)
	if (locale === "fr") return fr_home_hero_subtitle(inputs)
	if (locale === "it") return it_home_hero_subtitle(inputs)
	if (locale === "hu") return hu_home_hero_subtitle(inputs)
	if (locale === "nl") return nl_home_hero_subtitle(inputs)
	if (locale === "no") return no_home_hero_subtitle(inputs)
	if (locale === "pl") return pl_home_hero_subtitle(inputs)
	if (locale === "pt-BR") return pt_br2_home_hero_subtitle(inputs)
	if (locale === "pt") return pt_home_hero_subtitle(inputs)
	if (locale === "ro") return ro_home_hero_subtitle(inputs)
	if (locale === "fi") return fi_home_hero_subtitle(inputs)
	if (locale === "sv") return sv_home_hero_subtitle(inputs)
	if (locale === "vi") return vi_home_hero_subtitle(inputs)
	if (locale === "tr") return tr_home_hero_subtitle(inputs)
	if (locale === "cs") return cs_home_hero_subtitle(inputs)
	if (locale === "bg") return bg_home_hero_subtitle(inputs)
	if (locale === "ru") return ru_home_hero_subtitle(inputs)
	if (locale === "uk") return uk_home_hero_subtitle(inputs)
	if (locale === "ar") return ar_home_hero_subtitle(inputs)
	if (locale === "hi") return hi_home_hero_subtitle(inputs)
	if (locale === "th") return th_home_hero_subtitle(inputs)
	if (locale === "ja") return ja_home_hero_subtitle(inputs)
	if (locale === "zh-CN") return zh_cn2_home_hero_subtitle(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_hero_subtitle(inputs)
	return ko_home_hero_subtitle(inputs)
});
export { home_hero_subtitle as "home.hero.subtitle" }